import 'ion-rangeslider';

class RangeSlider {
	constructor(params) {
		this.node = params.node;
		this.options = params.options || {};
		this.onChange = params.onChange ? params.onChange : () => null;
		this.onLoad = params.onLoad ? params.onLoad : () => null;

		this.input = this.node.getElementsByClassName('js-range-slider')[0];
		this.from = this.node.getElementsByClassName('price-range-from')[0];
		this.to = this.node.getElementsByClassName('price-range-to')[0];

		this.slider = this.initSlider();

		this.from.addEventListener('input', () => {
			this.slider.update({
				from: this.from.value,
			});
			this.slider.callOnChange();
		});

		this.to.addEventListener('input', () => {
			this.slider.update({
				to: this.to.value,
			});
			this.slider.callOnChange();
		});

		this.onLoad(this.slider);
	}

	/**
	 * Slider initialization
	 */
	initSlider() {
		const slider = $(this.input);
		slider.ionRangeSlider({
			extra_classes: 'range-slider-component',
			skin: 'flat',
			type: 'double',
			hide_min_max: true,
			hide_from_to: true,
			grid: false,
			step: 500,
			min: 0,
			max: 5000,
			from: 0,
			to: 5000,
			onStart: data => {
				this.from.value = data.from;
				this.to.value = data.to;
			},
			onChange: data => {
				this.from.value = data.from;
				this.to.value = data.to;
				this.onChange(data);
			},
			...this.options,
		});
		return slider.data('ionRangeSlider');
	}

	/**
	 * Setting value of slider
	 *
	 * @param {object} data
	 */
	setValues(data) {
		const from = data.from || data.from === null ? { from: data.from || this.slider.options.min } : {};
		const to = data.to || data.to === null ? { to: data.to || this.slider.options.max } : {};

		this.slider.update({ ...from, ...to });

		if (data.from) this.from.value = data.from;
		else if (data.from === null) this.from.value = this.slider.options.min;
		if (data.to) this.to.value = data.to;
		else if (data.to === null) this.to.value = this.slider.options.max;
	}

	/**
	 * Getting values
	 *
	 * @returns {{from: string, to: string}}
	 */
	getValues() {
		return {
			from: this.from.value,
			to: this.to.value,
		};
	}
}

export default RangeSlider;
